"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedCountries = void 0;
exports.supportedCountries = [
    'ru',
    'kz',
    'by',
    'tr',
    'az',
    'am',
    'kg',
    'uz',
    'lv',
    'lt',
    'ro',
    'ee'
];
